import React from 'react'
import { Carousel } from 'antd';
import { Route, Router, Link } from 'react-router-dom'
import createHistory from 'history/createHashHistory';
const history = createHistory();
import './index.css';
import NHFetch from "../../utils/NHFetch";
import { getLoginUser } from '@utils/NHCore';
const baseUrl = 'api/zhxg-yxwz/';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sytp: [],//首页图片
            dhlm: [],//导航栏目
            dhlm1: [],//折叠的导航栏目
            settings: {},
            logoUUID: '', //LOGO图(对应文档库的UUID)
            selectData: '',//当前被选中的list项
            isCurrentYear: true, // 当前用户是否属于当前年度
        }
    }

    componentDidMount() {
        this.getYxwzLogo();
        this.getSytpList();
        this.checkStudentYear();
        setTimeout(() => {
            let settings = {
                effect: 'fade',
                dots: true,
                speed: 10000,
            }
            this.setState({
                settings: settings
            })
        }, 2000);
        this.updateSelectData()
        window.addEventListener('popstate', () => { '地址栏变化变化', this.updateSelectData() })
    }

    componentWillUnmount() {

    }

    updateSelectData = () => {
        this.setState({
            selectData: window.localStorage.getItem('selectData') ? window.localStorage.getItem('selectData') : '首页'
        })
    }

    //获取迎新网站LOGO
    getYxwzLogo = () => {
        NHFetch("api/zhxg-yxwz/dhlm/getLogo", "GET")
            .then(resData => {
                if (resData && resData.data) {
                    this.setState({
                        logoUUID: resData.data
                    });
                }
            });
    };

    // 检查当前用户是否属于当前年度
    checkStudentYear = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (xsid) {
            NHFetch('api/zhxg-yxwz/ydyxIndex/checkXsInDqnd', 'GET', { xsid }).then(res => {
                if (res && res.code === 200) {
                    const isCurrentYear = res.data === true;
                    this.setState({ isCurrentYear }, () => {
                        this.getDhlmList();
                    });
                } else {
                    this.getDhlmList();
                }
            }).catch(() => {
                this.getDhlmList();
            });
        } else {
            this.getDhlmList();
        }
    }

    getDhlmList = () => {
        let params = {}
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (xsid) {
            params = {
                xsfs: 2,
            }
        }
        NHFetch("api/zhxg-yxwz/dhlm/getDhlmList", "GET", params)
            .then(resData => {
                if (resData && resData.data) {
                    let data = resData.data;
                    // 非当前年度学生过滤掉"电子注册"导航项
                    if (!this.state.isCurrentYear) {
                        data = data.filter(item => item.lmmc !== '电子注册');
                    }
                    if (data.length > 6) {
                        this.setState({ dhlm: data.slice(0, 6), dhlm1: data.slice(6) })
                    } else {
                        this.setState({ dhlm: data });
                    }
                }
            });
    }

    getSytpList = () => {
        NHFetch("api/zhxg-yxwz/sytp/getSytpList", "GET")
            .then(resData => {
                if (resData && resData.data) {
                    this.setState({ sytp: resData.data });
                }
            });
    }


    click = (dhlm) => {
        let lmlx = dhlm['lmlx'];
        let flbz = dhlm['flbz'];
        let mkbz = dhlm['mkbz'];
        let flmid = dhlm['flmid'];
        let lmlj = dhlm['lmlj'];
        let pkid = dhlm['pkid'];
        let count = dhlm['childCount'];
        let isUnique = dhlm['isUnique'];
        this.setState({
            selectData: dhlm.lmmc
        })
        window.localStorage.setItem('selectData', dhlm.lmmc)
        this.updateSelectData()
        if (lmlx == '3') {
            history.push({
                pathname: '/' + mkbz,
            }
            );
        } else if (lmlx == '1') {
            if (isUnique === '1') {
                // 对隐私条款单独处理显示
                if (flbz === 'yctk') {
                    history.push({
                        pathname: '/notice/yctkDetail',
                        search: 'pkid=' + pkid,
                    }
                    );
                } else {
                    history.push({
                        pathname: '/notice/detail',
                        search: 'pkid=' + pkid,
                    }
                    );
                }

            } else {
                history.push({
                    pathname: '/notice',
                    search: 'flbz=' + flbz,
                }
                );
            }
        } else if (lmlx == '2') {
            if (count > 0) {
                history.push({
                    pathname: '/link',
                    search: 'pkid=' + pkid,
                }
                );
            } else {
                window.open(lmlj);
            }
        }

    }

    render() {
        const settings = this.state.settings;
        const { logoUUID } = this.state;
        let show = false;
        if (JSON.stringify(settings) === "{}") {
            show = false
        } else {
            show = true;
        }
        return (
            <div>
                {/* <div styleName="top">
                    <div styleName="top_con">
                        <img src={logoUUID ? "anonymity/docrepo/download?attachmentId=" + logoUUID : ''} alt=""/>
                    </div>
                </div> */}
                <div styleName="list">
                    <div styleName='listLogoDiv'>
                        <img src={require(`../../../assets/images/titleLogo.png`)} alt="" styleName='listLogo' />
                        <div styleName='rectStyle'></div>
                        <p styleName='textStyle'>迎新系统</p>
                    </div>
                    <div styleName="listTop">
                        {
                            this.state.dhlm.map((elem, index) => {
                                return (
                                    <span key={index} styleName='item' onClick={() => {
                                        this.click(elem);
                                        const ulElem = document.getElementsByClassName('ulElem')
                                        if (ulElem[0]) {
                                            ulElem[0].style.display = 'none'
                                        }
                                    }}>
                                        <span styleName={elem.lmmc == this.state.selectData ? 'active' : 'item1'} style={{ position: 'relative' }}>{elem.lmmc}
                                            {elem.sfrdlm_dm == "1" && <img src={require(`../../../assets/images/hot.png`)} style={{ position: "absolute", top: "9px", right: '-26px' }} />}
                                        </span>
                                    </span>
                                )
                            })


                        }
                        {
                            this.state.dhlm1.length > 0 && <div styleName='listTop1'>
                                <span onClick={() => {
                                    if (!(this.state.dhlm1.filter(item => item.lmmc == this.state.selectData).length)) {
                                        const ulElem = document.getElementsByClassName('ulElem')
                                        if (ulElem[0]) {
                                            ulElem[0].style.display = 'block'
                                        }
                                        this.setState({
                                            selectData: '...'
                                        }, () => {
                                            window.localStorage.setItem('selectData', this.state.selectData)
                                        })
                                    }
                                }} styleName={this.state.selectData == '...' || this.state.dhlm1.filter(item => item.lmmc == this.state.selectData).length ? 'active' : ''}>...
                                    <ul className='ulElem'>
                                        {this.state.dhlm1.map((elem, index) => {
                                            return (
                                                <li key={index} styleName={elem.lmmc == this.state.selectData ? 'activeLi' : ''} onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.click(elem);
                                                }} >
                                                    <span>{elem.lmmc}
                                                        {elem.sfrdlm_dm == "1" && <img src={require(`../../../assets/images/hot.png`)} style={{ position: "relative", top: "-8px" }} />}
                                                    </span>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </span>

                            </div>
                        }
                    </div>
                </div>
                <div className="_bg" styleName="banner">
                    {show ? <Carousel {...settings} autoplay>
                        {this.state.sytp.map((elem, index) => {
                            let pkid = elem['PKID'];
                            return (
                                <div styleName="banner" key={index}>
                                    <img style={{ width: '100%', height: '100%' }} src={"api/zhxg-yxwz/sytp/getPicture/" + pkid} alt="" />
                                </div>
                            )
                        })}
                    </Carousel> :
                        this.state.sytp.length > 0 &&
                        <div styleName="banner">
                            <img style={{ width: '100%', height: '100%' }} src={"api/zhxg-yxwz/sytp/getPicture/" + this.state.sytp[0].PKID} alt="" />
                        </div>
                    }
                </div>
            </div>
        )
    }
}